import { IEnvironment } from '@jissu-public/jissu-public-dm-dc/shared/model';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const environment: IEnvironment = {
  production: (window as any)['env']['production'],

  environmentBadge: (window as any)['env']['environmentBadge'],

  dcApi: (window as any)['env']['dcApi'],
  sokApi: (window as any)['env']['sokApi'],
  uaaApi: (window as any)['env']['uaaApi'],

  dcUiUrl: (window as any)['env']['dcUiUrl'],
  ntfUiUrl: (window as any)['env']['ntfUiUrl'],

  ntfWebSocketUrl: (window as any)['env']['ntfWebSocketUrl'],

  oidc: {
    authority: (window as any)['env']['oidc']['authority'],
    clientId: (window as any)['env']['oidc']['clientId'],
    secureRoutes: (window as any)['env']['oidc']['secureRoutes'],
    scope: (window as any)['env']['oidc']['scope'],
    redirectUrl: (window as any)['env']['oidc']['redirectUrl'],
    postLogoutRedirectUri: (window as any)['env']['oidc']['postLogoutRedirectUri'],
  },

  isPublic: true,
  googleAnalyticsId: (window as any)['env']['googleAnalyticsId'],
  feedbackUrl: (window as any)['env']['feedbackUrl'],
};
